import classNames from "classnames";
import React, { PropsWithChildren } from "react";

type CardPaddingStyle = "padded" | "compact";
type CardBorderStyle = "none" | "border" | "border-dark" | "shadow";
type CardColor = "default" | "yellow" | "pink";

interface CardProps extends PropsWithChildren {
  /** The amount of padding around the main card area. Generally cards in admin apps use the `padded` value while customer tools cards use the `compact` value.*/
  cardPaddingType?: CardPaddingStyle;
  /** Optional border style for a card. Customer tools cards usually use the `shadow` value while admin app card will usually use either `border` or `border-dark`*/
  cardBorderStyle?: CardBorderStyle;
  /** Changes the cards background colour via the `background--` utility classes*/
  cardColor?: CardColor;
}

export const Card: React.FC<CardProps> = ({
  cardBorderStyle = "none",
  cardPaddingType = "padded",
  cardColor,
  children,
}) => {
  const cardClasses = classNames("card", {
    "card--compact": cardPaddingType === "compact",
    [`card--${cardBorderStyle}`]: cardBorderStyle !== "none",
    [`background--${cardColor}`]: cardColor,
  });

  return <section className={cardClasses}>{children}</section>;
};
